import { type FunctionComponent, useMemo } from "react";
import { graphql, useFragment } from "react-relay";

import { article as articleData } from "shared/data/article";

import type { contentReadingTimeContent$key } from "scmp-app/queries/__generated__/contentReadingTimeContent.graphql";

import { Container } from "./styles";

type Props = {
  className?: string;
  reference: contentReadingTimeContent$key;
};

export const ContentReadingTime: FunctionComponent<Props> = ({ className, reference }) => {
  const content = useFragment(
    graphql`
      fragment contentReadingTimeContent on Content {
        readingTime
        flag
      }
    `,
    reference,
  );

  const readingTime = useMemo(() => {
    const readingTime = content?.readingTime ?? 0;
    if (readingTime > 1) return `${content.readingTime} minutes`;
    return "1 minute";
  }, [content.readingTime]);

  if (content.flag === articleData.flag.video) return null;

  return (
    <Container className={className}>
      <span>Reading Time:</span>
      <strong>{readingTime}</strong>
    </Container>
  );
};

ContentReadingTime.displayName = "ContentReadingTime";
``;
